import DuckModule from '../duckModule';

export default DuckModule({
    store: 'multi-view-gestione-licenze',
    initialState: {
        selected_view: '',
    },
    types: ['CHANGE_SELECTION'],
}).extend({
    reducer: (state, { type, payload }, { types }) => {
        switch (type) {
            case types.CHANGE_SELECTION:
                return { ...state, selected_view: payload.selected_view };
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        changeViewSelection: selected_view => ({
            type: types.CHANGE_SELECTION,
            payload: { selected_view },
        }),
    }),
});
